function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}
function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t =
    null == r ? null : ('undefined' != typeof Symbol && r[Symbol.iterator]) || r['@@iterator'];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (((i = (t = t.call(r)).next), 0 === l)) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {}
    } catch (r) {
      (o = !0), (n = r);
    } finally {
      try {
        if (!f && null != t.return && ((u = t.return()), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import * as React from 'react';
import { useEffect, useState } from 'react';
import { Checkbox, Button } from 'udesk-ui';
import {
  HeaderWrap,
  HeaderWrapAllCheck,
  HeaderWrapExtraButton,
  HeaderWrapCheckAllText,
  HeaderWrapAllCheckInfo,
  HeaderWrapAllCheckInfoNumber,
} from './components/HeaderWrap';
import { useLocaleReceiver } from '../../../locale-provider/LocaleReceiver';
var CheckAllComponent = function CheckAllComponent(props) {
  var checkedList = props.checkedList,
    handleCheckAllChange = props.handleCheckAllChange,
    dataSource = props.dataSource,
    handleCancelSelect = props.handleCancelSelect,
    itemDisable = props.itemDisable;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isIndeterminate = _useState2[0],
    setIsIndeterminate = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isCheckAll = _useState4[0],
    setIsCheckAll = _useState4[1];
  var _useLocaleReceiver = useLocaleReceiver('ListCheckboxHeader'),
    _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
    contextLocale = _useLocaleReceiver2[0];
  useEffect(
    function () {
      if (!checkedList.length) {
        setIsIndeterminate(false);
        setIsCheckAll(false);
        return;
      }
      var checkedIds =
        checkedList === null || checkedList === void 0
          ? void 0
          : checkedList.map(function (el) {
              return el.id;
            });
      var len = 0;
      var disableLen = 0;
      dataSource.forEach(function (el) {
        if (checkedIds.includes(el.id)) {
          if (
            typeof itemDisable === 'function' &&
            !(itemDisable === null || itemDisable === void 0 ? void 0 : itemDisable(el))
          ) {
            disableLen += 1;
          }
          len += 1;
        }
      });
      if (len === 0) {
        setIsIndeterminate(false);
        setIsCheckAll(false);
      } else if (len === dataSource.length) {
        setIsIndeterminate(false);
        setIsCheckAll(true);
      } else {
        if (typeof itemDisable === 'function') {
          var _dataSource$filter;
          var currDisableLen =
            (_dataSource$filter = dataSource.filter(function (el) {
              return !(itemDisable === null || itemDisable === void 0 ? void 0 : itemDisable(el));
            })) === null || _dataSource$filter === void 0
              ? void 0
              : _dataSource$filter.length;
          //len 判断了0的情况 这里就无须再次判断
          if (disableLen === currDisableLen) {
            setIsIndeterminate(false);
            setIsCheckAll(true);
          } else {
            setIsIndeterminate(true);
            setIsCheckAll(false);
          }
        } else {
          setIsIndeterminate(true);
          setIsCheckAll(false);
        }
      }
    },
    [dataSource, checkedList],
  );
  return /*#__PURE__*/ React.createElement(
    HeaderWrapAllCheck,
    null,
    /*#__PURE__*/ React.createElement(Checkbox, {
      disabled:
        dataSource === null || dataSource === void 0
          ? void 0
          : dataSource.every(function (el) {
              return itemDisable === null || itemDisable === void 0 ? void 0 : itemDisable(el);
            }),
      indeterminate: isIndeterminate,
      onChange: handleCheckAllChange,
      checked: isCheckAll,
    }),
    /*#__PURE__*/ React.createElement(HeaderWrapCheckAllText, null, contextLocale.lang.selectAll),
    checkedList.length
      ? /*#__PURE__*/ React.createElement(
          React.Fragment,
          null,
          /*#__PURE__*/ React.createElement(
            HeaderWrapAllCheckInfo,
            null,
            contextLocale.lang.selected,
            /*#__PURE__*/ React.createElement(
              HeaderWrapAllCheckInfoNumber,
              null,
              checkedList.length,
            ),
            contextLocale.lang.term,
          ),
          /*#__PURE__*/ React.createElement(
            Button,
            {
              className: 'allCheck-cancel',
              type: 'link',
              onClick: handleCancelSelect,
            },
            contextLocale.lang.deselect,
          ),
        )
      : null,
  );
};
var CheckAllComponentMemo = /*#__PURE__*/ React.memo(CheckAllComponent);
var ListHeader = function ListHeader(props) {
  var checkedList = props.checkedList,
    handleCheckAllChange = props.handleCheckAllChange,
    handleCancelSelect = props.handleCancelSelect,
    itemDisable = props.itemDisable,
    dataSource = props.dataSource,
    extraButton = props.extraButton;
  return /*#__PURE__*/ React.createElement(
    React.Fragment,
    null,
    /*#__PURE__*/ React.createElement(
      HeaderWrap,
      {
        checked: !!checkedList.length,
      },
      /*#__PURE__*/ React.createElement(CheckAllComponentMemo, {
        checkedList: checkedList,
        handleCheckAllChange: handleCheckAllChange,
        dataSource: dataSource,
        handleCancelSelect: handleCancelSelect,
        itemDisable: itemDisable,
      }),
      /*#__PURE__*/ React.createElement(HeaderWrapExtraButton, null, extraButton),
    ),
  );
};
export default ListHeader;
